import { Text } from 'ui'
import { useGateValue } from '@statsig/react-bindings'
import { FeatureGates } from 'lib/statsig/feature_gates'

export const LegacyProp22MileageBlock = () => {
  const enableProp22ShiftEditorAffirmation = useGateValue(
    FeatureGates.EnableProp22ShiftEditorAffirmation
  )
  return (
    <Text fontSize={1} color={'lightText'} mb={1}>
      {enableProp22ShiftEditorAffirmation ? (
        <>
          Let us know how far a worker should expect to drive. This will help us
          recommend competitive wages.
          <br />
          <br />
          WorkWhile requires that all California driving shifts performed by
          independent contractors must meet the following requirements:
          <br />
          <br />
          <ul
            style={{
              paddingLeft: '15px',
              listStyleType: 'disc',
            }}
          >
            <li>
              Delivery drivers may only perform delivery-related activities
              during delivery shifts (e.g., selecting and collecting the items
              to be delivered and delivering the selected items to customers)
            </li>
            <li>
              All delivery stops within the shift must be within a 50-mile
              radius of the pick-up location
            </li>
            <li>
              Drivers can be offered the opportunity to complete more than one
              route on the shift
            </li>
            <li>
              Each route must consist of no more than 12 distinct orders placed
              by different customers
            </li>
            <li>
              Drivers must be allowed to voluntarily decide whether to accept or
              decline each delivery route request offered to them on a shift,
              and no adverse action can be taken against a driver who decides to
              decline a delivery route request
            </li>
          </ul>
          <br />
          If a shift's actual mileage exceeds the estimated mileage, this may
          result in a surcharge to you, and additional payment to the worker, to
          comply with California regulatory requirements.
        </>
      ) : (
        <>
          Let us know how far a worker should expect to drive. This will help us
          recommend competitive wages. Under local California regulations,
          driving shifts must be limited to no more than 12 drops and stay
          within a 50-mile radius of the starting point.
          <br />
          <br />
          If a shift's actual mileage exceeds the estimated mileage, this may
          result in a surcharge to you, and additional payment to the worker, to
          comply with regulatory requirements.
        </>
      )}
    </Text>
  )
}
